import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { getIconCSSClass } from "../../utils/index";
import BrowserViewGlobal from "../../../Views/BrowserView";
import ActionPointTooltip from "../../ActionPointTooltip";
import useHover from "../../../hooks/useHover";

export default function DocumentLink({
  id,
  title,
  setModalIsOpen,
  modalIsOpen,
  getDocumentFileName,
  createNonInternalStream,
  linkDocument,
  left,
  top,
  iconKind,
  tabindex,
  backgroundColor,
}) {
  const linkRef = useRef(null);
  const toggle = () => setModalIsOpen(!modalIsOpen);
  const linkName =
    getDocumentFileName &&
    getDocumentFileName.match(/[^\/\\]*?\.[a-z0-9]+?$/i)[0];

  const [hover, hoverProps] = useHover();

  return (
    <BrowserViewGlobal>
      <a
        id={`action-point-${id}`}
        style={{
          top: `${top}%`,
          left: `${left}%`,
          backgroundColor: `#${backgroundColor}`,
        }}
        className={`view__links__dot ${getIconCSSClass(iconKind)}`}
        // title={title}
        download
        target="_blank"
        href={`${process.env.NEXT_PUBLIC_ROOT_URL}/download/${linkDocument}`}
        onClick={() => {
          toggle();
          createNonInternalStream();
        }}
        tabindex={tabindex}
        {...hoverProps}
      >
        <ActionPointTooltip show={hover} text={title} />
      </a>
      <Modal
        centered
        show={modalIsOpen}
        onHide={toggle}
        className="modal-custom modal-custom--document-link"
      >
        <div className="modal-custom__wrapper">
          <div
            onClick={toggle}
            className="modal-custom__close modal-custom__close--document-link"
          >
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div className="modal-custom__body--document-link">
            <div className="p-3 text-center">
              <h2 className="modal-custom__header--document-link">
                Your download has started!
              </h2>
              <p className="modal-custom__text--document-link">
                Once it´s done, the files will be on your computer <br />
                (often in the downloads folder).
              </p>
              <p className="modal-custom__text--document-link--small">
                <a
                  ref={linkRef}
                  download
                  className="modal-custom__link"
                  target="_blank"
                  href={`${process.env.NEXT_PUBLIC_ROOT_URL}/download/${linkName}`}
                >
                  Click here
                </a>
                &nbsp;to start your download manually
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </BrowserViewGlobal>
  );
}
